import LinearProgress from '@mui/material/LinearProgress';

import { toProgressValue } from 'ui/progress-bar/progress-bar.helpers';
import type { ProgressBarProps } from 'ui/progress-bar/progress-bar.types';

const ProgressBar = ({
  value = 0,
  'aria-label': ariaLabel,
  sx,
  'data-testid': dataTestId,
}: ProgressBarProps) => (
  <LinearProgress
    variant="determinate"
    color="secondary"
    value={toProgressValue(value)}
    aria-label={ariaLabel}
    sx={sx}
    data-testid={dataTestId}
  />
);

export default ProgressBar;
